module.exports = __webpack_public_path__ + "img/404.bae6a401.png";